import React from 'react';
import './Proficiencies.css';

const Proficiencies = ({ proficiencies }) => {
    const categories = [
        { key: 'languages', label: 'Languages' },
        { key: 'tools', label: 'Tools' },
        { key: 'weapons', label: 'Weapons' },
        { key: 'armor', label: 'Armor' }
    ];

    if (!proficiencies) return null;

    return (
        <div className="proficiencies-container">
            <h3>Proficiencies & Languages</h3>

            <div className="prof-grid">
                {categories.map(cat => {
                    const items = proficiencies[cat.key] || [];
                    if (items.length === 0) return null;

                    return (
                        <div key={cat.key} className="prof-category">
                            <h4>{cat.label}</h4>
                            <div className="prof-list">
                                {items.map(item => (
                                    <span key={item} className="prof-pill">{item}</span>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Proficiencies;
